import AutoDeleteRoundedIcon from '@mui/icons-material/AutoDeleteRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import LocalParkingRoundedIcon from '@mui/icons-material/LocalParkingRounded'
import MailLockRoundedIcon from '@mui/icons-material/MailLockRounded'
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded'
import TimerRoundedIcon from '@mui/icons-material/TimerRounded'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import { IntlShape, useIntl } from 'react-intl'
import { PaymentStatus } from '../../apis/parkingEvents/dto'

export const getPaymentStatusIconConfiguration = (props: {
  paymentStatus?: PaymentStatus
  intl: IntlShape
}) => {
  const { paymentStatus, intl } = props
  const iconConfigurations = (status?: PaymentStatus) => {
    switch (status) {
      case 'FREE':
        return {
          icon: <CheckCircleRoundedIcon color="success" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.free' }),
        }
      case 'PAID':
        return {
          icon: <PaymentsRoundedIcon color="success" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.paid' }),
        }
      case 'UNPAID':
        return {
          icon: <TimerRoundedIcon />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.unpaid' }),
        }
      case 'INVOICING':
        return {
          icon: <MailLockRoundedIcon color="error" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.invoicing' }),
        }
      case 'TIMED_OUT':
        return {
          icon: <AutoDeleteRoundedIcon color="error" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.timedOut' }),
        }
      // No status assigned
      case undefined:
      case null:
        return {
          icon: <LocalParkingRoundedIcon color="disabled" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.undefined' }),
        }
      // Fallback required for unexpected payment status cases not covered by OpenAPI
      default:
        return {
          icon: <WarningRoundedIcon color="error" />,
          tooltip: intl.formatMessage({ id: 'common.paymentStatus.unknown' }),
        }
    }
  }
  return iconConfigurations(paymentStatus)
}

type PaymentStatusIconProps = {
  paymentStatus?: PaymentStatus
}

const PaymentStatusIcon = (props: PaymentStatusIconProps) => {
  const { paymentStatus } = props
  const intl = useIntl()
  const { icon, tooltip } = getPaymentStatusIconConfiguration({
    paymentStatus,
    intl,
  })
  if (!icon) return null
  return <Tooltip title={tooltip}>{icon}</Tooltip>
}

export const PaymentStatusIconWithText = (props: PaymentStatusIconProps) => {
  const { paymentStatus } = props
  const intl = useIntl()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <PaymentStatusIcon paymentStatus={paymentStatus} />
      <Typography sx={{ ml: 0.5 }}>
        {
          getPaymentStatusIconConfiguration({
            intl,
            paymentStatus,
          }).tooltip
        }
      </Typography>
    </Box>
  )
}

export default PaymentStatusIcon
